const Footer = () => {
  return (
    <footer className="py-4 text-center">
      <p>&copy; 2026 Benjamin Ayesu-Attah</p>
    </footer>
  );
};

export default Footer;
